import { formatNumeric } from './numeric';

/**
 * Format ABN.
 *
 * @param value - ABN string.
 * @returns Formatted ABN string.
 */
export function formatABN(value?: string) {
  return formatNumeric(value, '## ### ### ###');
}
